import { Link } from "react-router";
import { Alert, buttonVariants } from "@heroui/react";
import { BookOpenIcon, PlusIcon } from "@heroicons/react/24/outline";

export const EmptyLibraryAlert = () => (
    <Alert className="mx-auto mb-8 sm:mb-10 max-w-2xl !bg-[var(--color-secondary-600)] !border-[var(--color-secondary-700)] sm:!items-center">
        <Alert.Indicator className="!text-[var(--color-accent-300)]">
            <BookOpenIcon className="h-8 w-8" />
        </Alert.Indicator>
        <Alert.Content>
            <Alert.Title className="!text-[var(--color-accent-300)] !text-lg">
                Your recipe book is unwritten
            </Alert.Title>
            <Alert.Description className="!text-white/85">
                Add your first recipe to write the first chapter.
            </Alert.Description>
            <Link
                to="/recipes/new"
                className={`${buttonVariants({ variant: "primary", size: "sm" })} mt-3 sm:hidden !bg-white !text-[var(--color-secondary-700)] hover:!bg-white/90`}
            >
                <PlusIcon className="h-4 w-4" />
                Add a recipe
            </Link>
        </Alert.Content>
        <Link
            to="/recipes/new"
            className={`${buttonVariants({ variant: "primary", size: "sm" })} hidden sm:inline-flex shrink-0 self-center !bg-white !text-[var(--color-secondary-700)] hover:!bg-white/90`}
        >
            <PlusIcon className="h-4 w-4" />
            Add a recipe
        </Link>
    </Alert>
);
